import { Component, inject, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';
import { Metadata } from 'src/app/shared/models/sys/metadata';
import { PageComponent } from '../../shared/components/page.component';
import { HomeDto } from '../../shared/models/dto/home-dto';
import {
  CardComponent,
  CardValue,
} from '../../shared/components/ui/card/card.component';
import { UiTourService } from '../../shared/services/ui-tour.service';
import { BurgerComponent } from '../../shared/components/ui/burger/burger.component';
import { RouterLink } from '@angular/router';
import { UiTourDirective } from '../../shared/directives/ui-tour.directive';
import { IconComponent } from '../../shared/components/ui/icon/icon.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { TranslateService } from '../../shared/services/translations/translate.service';
import { Translations } from '../../shared/constants/translations';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    BurgerComponent,
    RouterLink,
    UiTourDirective,
    CardComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class HomeComponent extends PageComponent implements OnInit {
  private readonly _uiTour: UiTourService = inject(UiTourService);
  private readonly _translate: TranslateService = inject(TranslateService);

  public figures?: HomeDto;
  public companies: CardValue[] = [];
  public employees: CardValue[] = [];
  public interns: CardValue[] = [];
  public selfEmployed: CardValue[] = [];
  public workStudies: CardValue[] = [];
  public students: CardValue[] = [];

  protected override get metadata(): Metadata {
    return {
      title: 'Les chiffres clés emploi formation du BTP',
      description:
        'Visualisez, filtrez et exportez les données statistiques du BTP.',
      keywords: 'chiffres, chiffres clés, emploi, formation, BTP, statistiques',
    };
  }

  public ngOnInit(): void {
    this.onMetadata();
    this._appState.homeFigures$
      .pipe(takeUntil(this._destroyed$))
      .subscribe((figures: HomeDto | undefined) => {
        this.figures = figures ?? {};

        this.companies = [
          {
            year: figures?.companies?.year.toLocaleString() ?? 'N/A',
            value: figures?.companies?.value.toLocaleString() ?? '-',
            unit: this._translate.instant(Translations.CardCompany),
            routerLink: this.routes.companies,
          },
        ];

        this.employees = [
          {
            year: figures?.employeesTotal?.year.toLocaleString() ?? 'N/A',
            value: figures?.employeesTotal?.value.toLocaleString() ?? '-',
            unit: this._translate.instant(Translations.CardEmployee),
            routerLink: this.routes.employees,
          },
        ];

        this.interns = [
          {
            year: figures?.interns?.year.toLocaleString() ?? 'N/A',
            value: figures?.interns?.value.toLocaleString() ?? '-',
            unit: this._translate.instant(Translations.CardInternship),
            routerLink: this.routes.interns,
          },
        ];

        this.selfEmployed = [
          {
            year: figures?.selfEmployed?.year.toLocaleString() ?? 'N/A',
            value: figures?.selfEmployed?.value.toLocaleString() ?? '-',
            unit: this._translate.instant(Translations.CardSelfEmployed),
            routerLink: this.routes.selfEmployed,
          },
        ];

        this.workStudies = [
          {
            year: figures?.apprenticeContracts?.year.toLocaleString() ?? 'N/A',
            value: figures?.apprenticeContracts?.value.toLocaleString() ?? '-',
            unit: this._translate.instant(Translations.CardPro),
            routerLink: this.routes.apprentices,
          },
          {
            year:
              figures?.professionalContracts?.year.toLocaleString() ?? 'N/A',
            value:
              figures?.professionalContracts?.value.toLocaleString() ?? '-',
            unit: this._translate.instant(Translations.CardApprentice),
            routerLink: this.routes.professionalsEvolution,
          },
        ];

        this.students = [
          {
            year: figures?.students?.year.toLocaleString() ?? 'N/A',
            value: figures?.students?.value.toLocaleString() ?? '-',
            unit: this._translate.instant(Translations.CardStudent),
            routerLink: this.routes.students,
          },
        ];
      });
  }

  public startTour(): void {
    this._uiTour.startTour();
  }
}
